import { fetcher } from "helpers/fetcher";

import {
  TupdateJobListingQualificationReq,
  TupdateJobListingQualificationRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListingQualification = async (
  payload: TupdateJobListingQualificationReq
) => {
  return await fetcher<
    TupdateJobListingQualificationRes,
    TupdateJobListingQualificationReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_QUALIFICATION, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_QUALIFICATION.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateJobListingQualification = async (
  payload: TupdateJobListingQualificationReq
) => {
  return (await updateJobListingQualification(payload)).data;
};

mutationUpdateJobListingQualification._key = (
  payload: TupdateJobListingQualificationReq
) => [ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_QUALIFICATION.url, payload];
